/** A one-record `BatchActionContext` — how a record page reuses a grid's batch dialog
 *  (Emit event, Reimport from stored XML) for the record it shows: the batch op with a
 *  one-element `ids` selection, the shape the API Requests grid's single-row reimport
 *  uses. Reusing the dialog keeps its options, its reason gate and its wire payload from
 *  drifting between the page and the grid. */
import type { BatchActionContext } from '@/components/DataGrid/batchTypes';

export function singleRecordBatchContext({
  id,
  tenantId,
  close,
  runStandard = () => Promise.resolve(),
}: {
  id: number;
  tenantId: number | null | undefined;
  /** Closes the dialog (also what "clear the selection" means on a page). */
  close: () => void;
  runStandard?: BatchActionContext['runStandard'];
}): BatchActionContext {
  return {
    selection: { mode: 'ids', ids: [id] },
    count: 1,
    matched: 1,
    matchedPhrase: '1 matching',
    filterQuery: '',
    tenantFilterId: tenantId ?? null,
    rowTenantIds: [tenantId ?? null],
    close,
    clearSelection: close,
    runStandard,
  };
}
